import type { SimpleChanges } from '@angular/core';
import { NgModel } from '@angular/forms';

type NgModelInternals = NgModel & {
  _registered: boolean;
  _parent: unknown;
};

let patched = false;

/**
 * SurveyJS wraps its UI in a native `<form>`, which Angular turns into NgForm.
 * Nested `ngModel` (SurveyJS child views and widgets we mount into the survey)
 * cannot register across that component boundary. They already behave as
 * standalone; mark them so Angular 22+ does not emit NG01354 (and a stack)
 * for every field.
 *
 * Mutating `ɵcmp.viewProviders` does not work: Ivy compiles providers at
 * definition time, and bridging *into* SurveyJS's NgForm is the wrong
 * direction (those controls are not Angular form fields).
 */
export function patchSurveyJsNgFormBridge(): void {
  if (patched) {
    return;
  }
  patched = true;

  if (typeof ngDevMode !== 'undefined' && !ngDevMode) {
    return;
  }

  const originalNgOnChanges = NgModel.prototype.ngOnChanges;
  NgModel.prototype.ngOnChanges = function (
    this: NgModel,
    changes: SimpleChanges
  ): void {
    const model = this as NgModelInternals;
    if (
      !model._registered &&
      model._parent === null &&
      !this.options?.standalone
    ) {
      this.options = { ...this.options, standalone: true };
    }
    originalNgOnChanges.call(this, changes);
  };
}

patchSurveyJsNgFormBridge();
